import populateActionButtonDataPoint from 'txp-data/lib/utils/telemetry/populateActionButtonDataPoint';
import ActivityType from 'txp-data/lib/schema/innerSchema/ActivityType';
import TxpDatapoint from 'txp-data/lib/schema/configSchema/TxpDatapoint';

export default function logActionDatapoint(
    actionName: string,
    datapointLogger: (txpDatapoint: TxpDatapoint, datapointName: string) => void,
    activityType: ActivityType,
    customData?: any
) {
    if (datapointLogger) {
        let dataPoint = populateActionButtonDataPoint(activityType, customData);
        datapointLogger(dataPoint, actionName);
    }
}
